import { graphql, PageProps, useStaticQuery } from 'gatsby'
import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useShallow } from 'zustand/react/shallow'
import { useUIStore } from '../../stores/ui/uiStore'
import { cn } from '../../Utils/component'
import { ApplicationModalForm } from '../application/ApplicationModalForm'
import { BaseCommandePalettes } from '../base/baseCommandePalette/BaseCommandePalettes'
import { CommandPaletteNames } from '../base/baseCommandePalette/CommandPaletteNames'
import { NewClientNotificationSubscriptionModal } from '../notification/NewClientNotificationSubscriptionModal'
import { AudioPlayer } from '../podcast/audio/player/AudioPlayer'
import { Footer } from './footer'
import { Header } from './header'

interface LayoutProps {
  children: React.ReactNode
  careerSite?: boolean
  hideFooter?: boolean
  colorCareerSite?: string
  apiUrl?: string
  apiToken?: string
  CustomHeader?: React.ReactNode
  location?: PageProps['location']
}

const Layout: React.FC<LayoutProps> = ({
  children,
  careerSite = false,
  hideFooter,
  colorCareerSite = undefined,
  CustomHeader = undefined,
  apiToken,
  apiUrl,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  location,
}) => {
  const isAudioPlayerSmall = useUIStore(useShallow(state => state.isAudioPlayerSmall))
  const isCommandePaletteOpen = useUIStore(useShallow(state => state.commandPalettesNameOpen))

  // Get Algolia configuration from site metadata
  const data = useStaticQuery(graphql`
    query LayoutQuery {
      site {
        siteMetadata {
          algolia {
            appId
            searchkey
            offersIndex
            firmsIndex
          }
        }
      }
    }
  `)

  const algoliaConfig = data.site?.siteMetadata?.algolia

  return (
    <ErrorBoundary fallbackRender={({ error }) => {
      console.error('Error in layout', error)
      return null
    }}>
      <div className="flex flex-col h-full min-h-screen">
        {CustomHeader || <Header hasCareerSite={careerSite} />}

        <main className="grow">{children}</main>
        <Footer
          isHidden={hideFooter}
          careerSite={careerSite}
          colorCareerSite={colorCareerSite}
        />
        <div
          className={cn(
            'fixed inset-x-0 bottom-0 z-10 transform ease-in-out transition-all duration-300',
            isAudioPlayerSmall
              ? 'md:left-[85%] lg:left-[90%]'
              : 'lg:left-112 xl:left-120',
          )}
        >
          <AudioPlayer />
        </div>
      </div>
      <ApplicationModalForm
        backendUrl={apiUrl || ''}
        frontStrapiToken={apiToken || ''}
      />
      <NewClientNotificationSubscriptionModal
        backendUrl={apiUrl || ''}
        frontStrapiToken={apiToken || ''}
      />
      <BaseCommandePalettes
        isOpen={isCommandePaletteOpen === CommandPaletteNames.SEARCH_FIRM_OFFER}
        algoliaConfig={algoliaConfig}
      />
    </ErrorBoundary>
  )
}

export default Layout
